<template>
  <div class="my-4">
    <page
      :articleSlug="articleSlug"
      :section="section"
      @pageTitle="pageTitle = $event"
    ></page>
    <div class="space"></div>
  </div>
</template>

<script>
import UserMixin from "@/assets/js/UserMixin";
import Page from "@/components/pagesStuff/Page";

export default {
  name: "PageHome",
  components: {
    Page,
  },
  mixins: [UserMixin],
  props: {},
  data: function () {
    return {
      pageTitle: null,
      articleSlug: null,
      section: null,
      defaultSection: "blog",

      defaultSlug: "about_eyedock",
    };
  },

  methods: {
    getSlugAndSection() {
      let slug = null;
      let article = this.$route.params?.article;
      let section = this.$route.params?.category;
      if (article) slug = article.toLowerCase();
      if (section) section = section.toLowerCase();

      this.articleSlug = slug ? slug : this.defaultSlug;
      this.section = section ? section : this.defaultSection;
    },
  },
  computed: {},
  watch: {},
  mounted() {
    this.getSlugAndSection();
  },
  metaInfo() {
    return {
      title: `EyeDock/${this.section} | ${
        this.pageTitle ? this.pageTitle : "Documentation"
      }`,
    };
  },
};
</script>

<style scoped>
/* .treeDiv {
  min-width: 280px;
} 
*/
.height100 {
  height: 100vh;
}
.width100 {
  width: 100%;
}
.overflow {
  overflow-y: auto;
}
.space {
  height: 100px;
}
</style>
